// this is specific to search because all other endpoints have skip/limit properties
export const getSearchPagination = (page?: number, pageSize = 10) => ({
  offset: page ? (page - 1) * pageSize : 0,
  limit: pageSize,
});
